import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { QUERY_RESSOURCES_TYPES } from '../../graphql/query/ressource/allRessources';
import { GetRessourcesTypesQuery } from '../../graphql/generated/graphql';
import { RessourcesTypeContainer } from 'components/molecules/Containers/RessourcesTypeContainer';
import { ChallengeRessourceTypes } from '../../types/ressource/ressource.def';

const Ressources = () => {
  const { loading: loadingType, error: errorType, data: dataType } = useQuery<
    GetRessourcesTypesQuery
  >(QUERY_RESSOURCES_TYPES);
  if (loadingType) return <LoadingLayout />;
  if (errorType)
    return (
      <ErrorContainer
        detailErr={
          new ApolloError({
            extraInfo: errorType,
            errorMessage: 'error query ressourcesAllByTypes'
          })
        }
        text="error query ressourcesAllByTypes"
      />
    );

  const challengeRessourceTypes: ChallengeRessourceTypes[] = dataType.findChallengeRessourceTypeWithRelatedChallengeRessources.map(
    type => ({
      id: type.id,
      name: type.name
    })
  );

  return (
    <RessourcesTypeContainer
      ressourcesType={challengeRessourceTypes}
      variant="orange"
    />
  );
};

export default Ressources;
